import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import {
  GetMarketplaceFeatureTypeV2Listings,
  GetMarketplaceFeatureTypeV2ListingsVariables
} from './__generated__/GetMarketplaceFeatureTypeV2Listings'

const QUERY = gql`
  query GetMarketplaceFeatureTypeV2Listings($id: String!) {
    marketplaceFeatureTypeV2(id: $id) {
      ... on MarketplaceFeatureTypeV2 {
        id
        title
        marketplaceListings {
          id
          title
          icon
        }
      }
      ... on MarketplaceFeatureTypeErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetMarketplaceFeatureTypeV2Listings = (id: string) =>
  useQuery<GetMarketplaceFeatureTypeV2Listings, GetMarketplaceFeatureTypeV2ListingsVariables>(QUERY, {
    variables: { id },
    fetchPolicy: 'network-only'
  })
